// Constant: Options > Languages
const LANGUAGES = Object.freeze(['ar', 'en', 'tr'])

// Constant: Options > Themes
const THEMES = Object.freeze(['dark', 'light'])

// Export
export {
	LANGUAGES,
	THEMES
}
